/* eslint-disable import/prefer-default-export */

const root = 'https://signin.tachyon.ws';

export const URLControlAPIAuthSignIn = () => `${root}/user/signin`;
